import React, { useEffect, useState } from 'react';
import { PillTextbox } from '../types';
import { PillContent } from '../../model/types';
import { setPillMinWidth, setPillPaddingX, setPillPaddingY } from '../utils/pill-accessors';
import { usePillContent } from '../hooks/use-pill-content';
import { labelStyle, rowStyle, sectionStyle, sliderStyle, valueLabelStyle } from './pill-styles';

type Props = { pill: PillTextbox };

type SliderRow = {
  label: string;
  value: number;
  max: number;
  suffix: string;
  preview: (v: number) => void;
  commit: () => void;
};

export const PillSizeRow: React.FC<Props> = ({ pill }) => {
  const { content, patch } = usePillContent(pill);
  const [minWidth, setMinWidth] = useState(0);
  const [paddingX, setPaddingX] = useState(0);
  const [paddingY, setPaddingY] = useState(0);

  useEffect(() => {
    if (!content) return;
    setMinWidth(content.minWidth);
    setPaddingX(content.paddingX);
    setPaddingY(content.paddingY);
  }, [content]);

  // onChange previews (accessor); onPointerUp commits to the model.
  const field = (
    label: string,
    value: number,
    max: number,
    suffix: string,
    setState: (v: number) => void,
    setAccessor: (p: PillTextbox, v: number) => void,
    key: keyof PillContent
  ): SliderRow => ({
    label,
    value,
    max,
    suffix,
    preview: v => {
      setState(v);
      setAccessor(pill, v);
    },
    commit: () => patch({ [key]: value } as Partial<PillContent>)
  });

  const rows: SliderRow[] = [
    field('Ancho mín.', minWidth, 1000, 'px', setMinWidth, setPillMinWidth, 'minWidth'),
    field('Pad X', paddingX, 100, '', setPaddingX, setPillPaddingX, 'paddingX'),
    field('Pad Y', paddingY, 100, '', setPaddingY, setPillPaddingY, 'paddingY')
  ];

  return (
    <div style={sectionStyle}>
      <div style={labelStyle}>Tamaño</div>
      {rows.map((r, i) => (
        <div key={r.label} style={{ ...rowStyle, marginTop: i === 0 ? 0 : 6 }}>
          <span style={{ ...labelStyle, minWidth: 70, marginBottom: 0 }}>{r.label}</span>
          <input
            type='range'
            min={0}
            max={r.max}
            step={1}
            value={r.value}
            onChange={e => r.preview(Number(e.target.value))}
            onPointerUp={r.commit}
            style={sliderStyle}
          />
          <span style={valueLabelStyle}>
            {r.value.toFixed(0)}
            {r.suffix}
          </span>
        </div>
      ))}
    </div>
  );
};
